/**
 * KAN-743: фильтры каталога в URL (?category=&search=&available=), чтобы
 * ссылкой можно было поделиться. Поле поиска живёт локально и попадает в
 * URL с задержкой 300 мс; пустые значения из URL убираются.
 */
import { useCallback } from 'react';
import { useUrlFilters, useUrlSearch } from '@/hooks/useUrlFilters';
import type { CatalogAvailability } from '@/types/catalog';

const toAvailability = (value: string | null): CatalogAvailability =>
  value === 'true' || value === 'false' ? value : 'all';

export interface CatalogFilters {
  category: string | null;
  /** Применённый поиск (из URL). */
  search: string;
  /** Текст в поле поиска (до задержки). */
  searchInput: string;
  availability: CatalogAvailability;
  setCategory: (id: string | null) => void;
  setSearchInput: (value: string) => void;
  setAvailability: (value: CatalogAvailability) => void;
}

export function useCatalogFilters(): CatalogFilters {
  const { searchParams, update } = useUrlFilters();
  const category = searchParams.get('category') || null;
  const availability = toAvailability(searchParams.get('available'));
  const { search, searchInput, setSearchInput } = useUrlSearch(searchParams, update);

  const setCategory = useCallback((id: string | null) => update('category', id), [update]);
  const setAvailability = useCallback(
    (value: CatalogAvailability) => update('available', value === 'all' ? null : value),
    [update]
  );

  return { category, search, searchInput, availability, setCategory, setSearchInput, setAvailability };
}
